<div class="group-cell-wrapper">
  <div class="left-wrapper">
    <h3 class="group-name-text">{{name}}</h3>
  </div>
  <div class="right-wrapper">
    <span class="patient-count">{{patientCount}} patient{{patientCount > 1 ? 's' : ''}}</span>
  </div>
</div>
